import { motion } from 'framer-motion';
import { CheckCircle2, CalendarDays, FileBadge } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { staggerItem } from '../ui/motionVariants';

interface Activity {
  id: string;
  icon: LucideIcon;
  title: string;
  time: string;
  tone: 'brand' | 'gold' | 'success' | 'muted';
}

const TONE_CLASSES = {
  brand: 'bg-primary/10 text-primary ring-primary/20',
  gold: 'bg-accent/15 text-accent ring-accent/20',
  success: 'bg-success/10 text-success ring-success/20',
  muted: 'bg-muted text-muted-foreground ring-muted-foreground/20',
};

const activities: Activity[] = [
  {
    id: '1',
    icon: FileBadge,
    title: 'Initial report generated',
    time: '2 days ago',
    tone: 'brand',
  },
  {
    id: '2',
    icon: CheckCircle2,
    title: 'Onboarding questionnaire completed',
    time: '3 days ago',
    tone: 'success',
  },
  {
    id: '3',
    icon: CalendarDays,
    title: 'First session scheduled',
    time: '1 week ago',
    tone: 'muted',
  },
];

export function ActivityTimeline(): JSX.Element {
  return (
    <motion.div
      variants={staggerItem}
      className="flex flex-col gap-5 bg-card border border-border p-6 rounded-3xl ring-1 ring-foreground/5 shadow-soft h-full"
    >
      <h2 className="text-lg font-display font-semibold tracking-tight">Recent Activity</h2>
      <div className="relative pl-4 border-l border-border/60 ml-2 mt-2 space-y-7 flex-1">
        {activities.map((activity) => (
          <div key={activity.id} className="relative">
            <div
              className={`absolute -left-[25px] top-0 flex items-center justify-center w-6 h-6 rounded-full bg-card ring-2 ring-background`}
            >
              <div
                className={`flex items-center justify-center w-full h-full rounded-full ring-1 ${TONE_CLASSES[activity.tone]}`}
              >
                <activity.icon className="w-3 h-3" />
              </div>
            </div>
            <div className="flex flex-col pl-3 -mt-1">
              <span className="text-sm font-medium text-foreground">{activity.title}</span>
              <span className="text-xs text-muted-foreground mt-0.5">{activity.time}</span>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
